var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThanks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 270,
    viewBox: "0 0 270 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1164_11272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.324 270.001C210.061 270.001 270.647 209.415 270.647 134.677C270.647 59.94 210.061 -0.646484 135.324 -0.646484C60.5865 -0.646484 0 59.94 0 134.677C0 209.415 60.5865 270.001 135.324 270.001Z",
    fill: "#F3781F",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.935 9.96094H56.75V56.1547H101.935V9.96094Z",
    fill: "#F4FBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.94 56.1543H120.555V9.96056H101.94V56.1543Z",
    fill: "#D6EEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8234 9.96094H73.875V29.1191H84.8234V9.96094Z",
    fill: "#D6EEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 13.4297L118.156 51.9121",
    stroke: "#F4FBFB",
    strokeWidth: 1.56367,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 51.9121L118.156 13.4297",
    stroke: "#F4FBFB",
    strokeWidth: 1.56367,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.068 9.96094H108.883V56.1547H154.068V9.96094Z",
    fill: "#F4FBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.065 56.1543H172.68V9.96056H154.065V56.1543Z",
    fill: "#D6EEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.948 9.96094H126V29.1191H136.948V9.96094Z",
    fill: "#D6EEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.125 13.4297L170.284 51.9121",
    stroke: "#F4FBFB",
    strokeWidth: 1.56367,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.125 51.9121L170.284 13.4297",
    stroke: "#F4FBFB",
    strokeWidth: 1.56367,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.934 55.6406H35.8281V61.815H181.934V55.6406Z",
    fill: "#D6EEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.404 122.24H92.2188V168.434H137.404V122.24Z",
    fill: "#F4FBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.4 168.432H156.016V122.238H137.4V168.432Z",
    fill: "#D6EEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.284 122.24H109.336V141.398H120.284V122.24Z",
    fill: "#D6EEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.469 125.709L153.628 164.188",
    stroke: "#F4FBFB",
    strokeWidth: 1.56367,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.469 164.188L153.628 125.709",
    stroke: "#F4FBFB",
    strokeWidth: 1.56367,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.536 122.24H144.352V168.434H189.536V122.24Z",
    fill: "#F4FBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.533 168.432H208.148V122.238H189.533V168.432Z",
    fill: "#D6EEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.417 122.24H161.469V141.398H172.417V122.24Z",
    fill: "#D6EEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.594 125.709L205.753 164.188",
    stroke: "#F4FBFB",
    strokeWidth: 1.56367,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.594 164.188L205.753 125.709",
    stroke: "#F4FBFB",
    strokeWidth: 1.56367,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.474 75.625H120.289V121.819H165.474V75.625Z",
    fill: "#F4FBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.471 121.816H184.086V75.6227H165.471V121.816Z",
    fill: "#D6EEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.355 75.625H137.406V94.7831H148.355V75.625Z",
    fill: "#D6EEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.539 79.0938L181.695 117.573",
    stroke: "#F4FBFB",
    strokeWidth: 1.56367,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.539 117.573L181.695 79.0938",
    stroke: "#F4FBFB",
    strokeWidth: 1.56367,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.337 167.92H71.2969V174.094H273.337V167.92Z",
    fill: "#D6EEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3485 140.307H37.4453V197.487H54.3485V140.307Z",
    fill: "#9ACCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3468 197.492H71.25V140.312H54.3468L54.3468 197.492Z",
    fill: "#7398A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3468 254.674H71.25V197.493H54.3468L54.3468 254.674Z",
    fill: "url(#paint0_linear_1164_11272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8906 148.762C50.5591 148.762 54.3436 144.977 54.3436 140.309C54.3436 135.64 50.5591 131.855 45.8906 131.855C41.2221 131.855 37.4375 135.64 37.4375 140.309C37.4375 144.977 41.2221 148.762 45.8906 148.762Z",
    fill: "#9ACCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3485 197.488H37.4453V254.669H54.3485V197.488Z",
    fill: "url(#paint1_linear_1164_11272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8906 263.135C50.5591 263.135 54.3436 259.35 54.3436 254.682C54.3436 250.013 50.5591 246.229 45.8906 246.229C41.2221 246.229 37.4375 250.013 37.4375 254.682C37.4375 259.35 41.2221 263.135 45.8906 263.135Z",
    fill: "#74ABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8906 205.947C50.5591 205.947 54.3436 202.163 54.3436 197.494C54.3436 192.826 50.5591 189.041 45.8906 189.041C41.2221 189.041 37.4375 192.826 37.4375 197.494C37.4375 202.163 41.2221 205.947 45.8906 205.947Z",
    fill: "#9ACCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8046 148.762C67.4731 148.762 71.2577 144.977 71.2577 140.309C71.2577 135.64 67.4731 131.855 62.8046 131.855C58.1361 131.855 54.3516 135.64 54.3516 140.309C54.3516 144.977 58.1361 148.762 62.8046 148.762Z",
    fill: "#7398A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8046 263.135C67.4731 263.135 71.2577 259.35 71.2577 254.682C71.2577 250.013 67.4731 246.229 62.8046 246.229C58.1361 246.229 54.3516 250.013 54.3516 254.682C54.3516 259.35 58.1361 263.135 62.8046 263.135Z",
    fill: "#537984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8046 205.947C67.4731 205.947 71.2577 202.163 71.2577 197.494C71.2577 192.826 67.4731 189.041 62.8046 189.041C58.1361 189.041 54.3516 192.826 54.3516 197.494C54.3516 202.163 58.1361 205.947 62.8046 205.947Z",
    fill: "#7398A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.692 178.385H98.3281V245.208H163.692V178.385Z",
    fill: "url(#paint2_linear_1164_11272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.696 245.211H190.625V178.387H163.696V245.211Z",
    fill: "#DA5F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.929 178.385H123.094V206.097H138.929V178.385Z",
    fill: "#DA5F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.333 111.721H144.969V178.544H210.333V111.721Z",
    fill: "url(#paint3_linear_1164_11272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.329 178.545H237.258V111.721H210.329V178.545Z",
    fill: "#DA5F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.569 111.721H169.734V139.433H185.569V111.721Z",
    fill: "#DA5F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.864 178.385H166.5V245.208H231.864V178.385Z",
    fill: "url(#paint4_linear_1164_11272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.868 245.211H258.797V178.387H231.868V245.211Z",
    fill: "#DA5F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.101 178.385H191.266V206.097H207.101V178.385Z",
    fill: "#DA5F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.581 16.0625H163.221C164.855 16.0625 166.422 16.7115 167.577 17.8666C168.732 19.0217 169.381 20.5884 169.381 22.2221V45.4332C169.381 47.0668 168.732 48.6335 167.577 49.7886C166.422 50.9438 164.855 51.5927 163.221 51.5927H119.422V22.2191C119.423 20.586 120.072 19.02 121.227 17.8655C122.382 16.711 123.948 16.0625 125.581 16.0625V16.0625Z",
    fill: "url(#paint5_linear_1164_11272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.357 43.3931L131.562 33.5989L134.805 30.3559L141.357 36.9101L153.996 24.2676L157.239 27.5105L141.357 43.3931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6642 269.145C78.6671 269.145 98.1253 266.913 98.1253 264.16C98.1253 261.407 78.6671 259.176 54.6642 259.176C30.6613 259.176 11.2031 261.407 11.2031 264.16C11.2031 266.913 30.6613 269.145 54.6642 269.145Z",
    fill: "#E7F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2424 138.262C98.1248 138.262 100.461 135.926 100.461 133.043C100.461 130.161 98.1248 127.824 95.2424 127.824C92.3601 127.824 90.0234 130.161 90.0234 133.043C90.0234 135.926 92.3601 138.262 95.2424 138.262Z",
    fill: "#CC6667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.172 105.663C131.055 105.663 133.391 103.326 133.391 100.444C133.391 97.5612 131.055 95.2246 128.172 95.2246C125.29 95.2246 122.953 97.5612 122.953 100.444C122.953 103.326 125.29 105.663 128.172 105.663Z",
    fill: "#CC6667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5551 129.334L98.8984 136.752L131.828 104.154L124.485 96.7356L91.5551 129.334Z",
    fill: "#CC6667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5334 97.1061L58.2812 104.613L91.6071 136.807L98.8592 129.3L65.5334 97.1061Z",
    fill: "url(#paint6_linear_1164_11272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9065 106.069C64.7889 106.069 67.1255 103.732 67.1255 100.85C67.1255 97.9675 64.7889 95.6309 61.9065 95.6309C59.0241 95.6309 56.6875 97.9675 56.6875 100.85C56.6875 103.732 59.0241 106.069 61.9065 106.069Z",
    fill: "#822727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.765 103.328C136.869 103.328 140.195 100.001 140.195 95.8982C140.195 91.795 136.869 88.4688 132.765 88.4688C128.662 88.4688 125.336 91.795 125.336 95.8982C125.336 100.001 128.662 103.328 132.765 103.328Z",
    fill: "#CC6667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2922 97.0776L58.3125 106.373L76.1821 123.636L85.1618 114.34L67.2922 97.0776Z",
    fill: "#FFEDC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8059 108.174C66.3749 108.174 69.2682 105.281 69.2682 101.712C69.2682 98.1432 66.3749 95.25 62.8059 95.25C59.237 95.25 56.3438 98.1432 56.3438 101.712C56.3438 105.281 59.237 108.174 62.8059 108.174Z",
    fill: "#FFEDC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1281 85.8652H48.4766V93.9623H60.1281V85.8652Z",
    fill: "#B54C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3452 254.67H36.8516V265.568H54.3452V254.67Z",
    fill: "#333164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8516 265.57H30.3241C28.8785 265.57 27.4922 264.996 26.47 263.974C25.4479 262.952 24.8736 261.565 24.8736 260.12V260.12C24.8736 258.674 25.4479 257.288 26.47 256.266C27.4922 255.244 28.8785 254.669 30.3241 254.669H36.8516V265.57Z",
    fill: "#333164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8567 265.571C39.8669 265.571 42.3071 263.131 42.3071 260.12C42.3071 257.11 39.8669 254.67 36.8567 254.67C33.8465 254.67 31.4062 257.11 31.4062 260.12C31.4062 263.131 33.8465 265.571 36.8567 265.571Z",
    fill: "#333164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3501 265.57H71.8438V254.672H54.3501V265.57Z",
    fill: "#34184C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8438 254.67H78.3712C79.087 254.67 79.7957 254.811 80.457 255.085C81.1183 255.359 81.7191 255.76 82.2253 256.266C82.7314 256.772 83.1329 257.373 83.4068 258.035C83.6807 258.696 83.8217 259.405 83.8217 260.12V260.12C83.8217 260.836 83.6807 261.545 83.4068 262.206C83.1329 262.867 82.7314 263.468 82.2253 263.974C81.7191 264.481 81.1183 264.882 80.457 265.156C79.7957 265.43 79.087 265.571 78.3712 265.571H71.8438V254.67Z",
    fill: "#34184C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8411 265.571C74.8513 265.571 77.2915 263.131 77.2915 260.12C77.2915 257.11 74.8513 254.67 71.8411 254.67C68.8309 254.67 66.3906 257.11 66.3906 260.12C66.3906 263.131 68.8309 265.571 71.8411 265.571Z",
    fill: "#34184C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6268 54.6259C74.6268 43.4028 65.5287 34.3047 54.3056 34.3047C43.0825 34.3047 33.9844 43.4028 33.9844 54.6259V71.2057C33.9844 82.4288 43.0825 91.5269 54.3056 91.5269C65.5287 91.5269 74.6268 82.4288 74.6268 71.2057V54.6259Z",
    fill: "url(#paint7_linear_1164_11272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9398 93.2715H49.656C43.6534 93.2715 37.8968 95.656 33.6524 99.9004C29.4079 104.145 27.0234 109.902 27.0234 115.904V115.904C27.0215 119.721 27.9717 123.478 29.7881 126.835C31.6045 130.193 34.2297 133.044 37.4259 135.13H71.1699C74.3661 133.044 76.9913 130.193 78.8077 126.835C80.6241 123.478 81.5743 119.721 81.5723 115.904V115.904C81.5723 109.902 79.1878 104.145 74.9434 99.9004C70.699 95.656 64.9423 93.2715 58.9398 93.2715V93.2715Z",
    fill: "url(#paint8_linear_1164_11272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4397 135.131H71.246V140.302C71.246 144.788 69.4642 149.089 66.2926 152.261C63.121 155.433 58.8193 157.214 54.334 157.214C49.8486 157.214 45.5469 155.433 42.3753 152.261C39.2037 149.089 37.4219 144.788 37.4219 140.302V135.131H37.4397Z",
    fill: "#9ACCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.344 145.756C71.2264 145.756 73.563 143.42 73.563 140.537C73.563 137.655 71.2264 135.318 68.344 135.318C65.4616 135.318 63.125 137.655 63.125 140.537C63.125 143.42 65.4616 145.756 68.344 145.756Z",
    fill: "#CC6667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2503 108.766C99.1326 108.766 101.469 106.43 101.469 103.547C101.469 100.665 99.1326 98.3281 96.2503 98.3281C93.3679 98.3281 91.0312 100.665 91.0312 103.547C91.0312 106.43 93.3679 108.766 96.2503 108.766Z",
    fill: "#CC6667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7902 137.421L72.1406 143.684L99.9423 106.615L91.5919 100.352L63.7902 137.421Z",
    fill: "#CC6667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1209 97.1992L41.9141 102.117L63.7461 142.988L72.9529 138.07L51.1209 97.1992Z",
    fill: "url(#paint9_linear_1164_11272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5081 104.881C49.3905 104.881 51.7271 102.545 51.7271 99.6624C51.7271 96.78 49.3905 94.4434 46.5081 94.4434C43.6257 94.4434 41.2891 96.78 41.2891 99.6624C41.2891 102.545 43.6257 104.881 46.5081 104.881Z",
    fill: "#822727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.148 105.816C104.251 105.816 107.578 102.49 107.578 98.3865C107.578 94.2833 104.251 90.957 100.148 90.957C96.045 90.957 92.7188 94.2833 92.7188 98.3865C92.7188 102.49 96.045 105.816 100.148 105.816Z",
    fill: "#CC6667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7983 97.7093L41.3984 103.799L53.105 125.714L64.5049 119.625L52.7983 97.7093Z",
    fill: "#FFEDC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.095 107.223C50.664 107.223 53.5572 104.33 53.5572 100.761C53.5572 97.1921 50.664 94.2988 47.095 94.2988C43.526 94.2988 40.6328 97.1921 40.6328 100.761C40.6328 104.33 43.526 107.223 47.095 107.223Z",
    fill: "#FFEDC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3432 120.521H123.921C124.829 120.528 125.714 120.235 126.438 119.687C127.163 119.14 127.687 118.37 127.929 117.495L140.729 69.5032C140.813 69.1791 140.82 68.8401 140.752 68.5126C140.683 68.1851 140.539 67.8778 140.332 67.6149C140.125 67.3519 139.86 67.1402 139.558 66.9963C139.256 66.8525 138.925 66.7803 138.59 66.7854H104.012C103.102 66.7769 102.214 67.0696 101.486 67.618C100.759 68.1664 100.234 68.9397 99.9919 69.8177L87.204 117.792C87.1188 118.116 87.11 118.457 87.1781 118.785C87.2462 119.114 87.3894 119.423 87.5965 119.687C87.8036 119.951 88.0691 120.164 88.3721 120.309C88.6751 120.454 89.0074 120.526 89.3432 120.521V120.521Z",
    fill: "#99B7CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.237 84.4959H122.434C122.807 84.4986 123.171 84.3778 123.468 84.1524C123.765 83.927 123.98 83.6097 124.078 83.2497L129.336 63.5516C129.371 63.4176 129.374 63.2771 129.345 63.1415C129.317 63.0059 129.257 62.8789 129.17 62.7705C129.084 62.6622 128.973 62.5755 128.848 62.5174C128.722 62.4594 128.584 62.4315 128.445 62.436H114.26C113.887 62.4337 113.523 62.5545 113.225 62.7798C112.928 63.0051 112.713 63.3223 112.613 63.6822L107.359 83.3744C107.323 83.5078 107.318 83.6478 107.346 83.7833C107.373 83.9188 107.432 84.0459 107.517 84.1548C107.603 84.2636 107.712 84.3511 107.837 84.4103C107.962 84.4695 108.099 84.4988 108.237 84.4959Z",
    fill: "#99B7CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1517 64.1523C71.1065 66.7803 70.0308 69.2853 68.1564 71.1277C66.282 72.9701 63.7588 74.0025 61.1305 74.0025C58.5022 74.0025 55.9791 72.9701 54.1047 71.1277C52.2303 69.2853 51.1546 66.7803 51.1094 64.1523H71.1517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.525 58.7277C35.1784 58.7277 36.5187 57.3874 36.5187 55.734C36.5187 54.0806 35.1784 52.7402 33.525 52.7402C31.8716 52.7402 30.5312 54.0806 30.5312 55.734C30.5312 57.3874 31.8716 58.7277 33.525 58.7277Z",
    fill: "#CC6667"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1164_11272",
    x1: 62.7969,
    y1: 197.49,
    x2: 62.7969,
    y2: 254.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#7398A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#537984"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1164_11272",
    x1: 45.8954,
    y1: 197.488,
    x2: 45.8954,
    y2: 254.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9ACCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#74ABAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1164_11272",
    x1: 97.9632,
    y1: 178.753,
    x2: 164.06,
    y2: 244.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FEA48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7867"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1164_11272",
    x1: 32000.7,
    y1: 25355.6,
    x2: 46882.6,
    y2: 39912.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FEA48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7867"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1164_11272",
    x1: 36766.3,
    y1: 40436.9,
    x2: 51648.2,
    y2: 54993.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FEA48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7867"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1164_11272",
    x1: 123.932,
    y1: 15.1635,
    x2: 163.067,
    y2: 54.3016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#9CDB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67C81E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1164_11272",
    x1: 61.9073,
    y1: 100.86,
    x2: 95.2332,
    y2: 133.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#822727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CC6667"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1164_11272",
    x1: 54.3056,
    y1: 34.3047,
    x2: 54.3056,
    y2: 91.5269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#CC6667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B54C4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1164_11272",
    x1: 54.2994,
    y1: 135.13,
    x2: 54.2994,
    y2: 93.2715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5D99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFEDC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1164_11272",
    x1: 8826.88,
    y1: 13052,
    x2: 12236.4,
    y2: 19434.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#822727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CC6667"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1164_11272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 270,
    height: 270,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanks);
export default __webpack_public_path__ + "static/media/thanks.5041f308026d527a6f1d6dc8738a9c31.svg";
export { ForwardRef as ReactComponent };